import { useMediaQuery } from "@vueuse/core";

const isDesktop = useMediaQuery("(min-width: 1024px)");
const isMobile = useMediaQuery("(max-width: 767px)");

export default {
  install: function(app /*, options*/) {
    app.mixin({
      computed: {
        isDesktop() {
          return isDesktop.value;
        },
        isMobile() {
          return isMobile.value;
        }
      }
    });
  }
};
